module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.list), function(p) {
    return _c('div', {
      key: p.id,
      staticClass: "integral"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": p.image_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(p.activity_name))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(p.info))]), _vm._v(" "), _c('div', {
      staticClass: "action"
    }, [_c('div', {
      staticClass: "input-number"
    }, [_c('span', [_vm._v("兑换数量 ")]), _c('el-input-number', {
      attrs: {
        "size": "small",
        "min": 1,
        "max": _vm.max
      },
      model: {
        value: (_vm.num),
        callback: function($$v) {
          _vm.num = $$v
        },
        expression: "num"
      }
    })], 1), _vm._v(" "), (p.status == 0) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.exchange(p)
        }
      }
    }, [_vm._v("申请兑换")]) : _c('div', {
      staticClass: "btn",
      staticStyle: {
        "background": "#D8DCE5"
      }
    }, [_vm._v("已过期")])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4210d3cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/integral/exchange.vue
// module id = 1120
// module chunks = 1